import { render, staticRenderFns } from "./BirthdayForm.vue?vue&type=template&id=5c425110&"
import script from "./BirthdayForm.vue?vue&type=script&lang=ts&"
export * from "./BirthdayForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports